import React from 'react';
import {Icon} from '@wordpress/components';
import {MagnifyingGlassIcon, CloseIcon} from '../../../common';
import {Box, Stack, Input} from '@lapilli-ui/components';
import Submit from './submit';
import {YWCAS_LANG, YWCAS_SITE_URL} from '../../../config';

const SearchField = ({
                         queryString,
                         placeholder,
                         placeholderTextColor,
                         inputTextColor,
                         inputBgColor,
                         inputBgFocusColor,
                         inputBorderColor,
                         inputBorderFocusColor,
                         inputBorderSize,
                         inputBorderRadius,
                         submitContentColor,
                         submitContentHoverColor,
                         submitBgColor,
                         submitBgHoverColor,
                         submitBorderColor,
                         submitBorderHoverColor,
                         submitStyle,
                         size,
                         setSearchQuery,
                         iconType,
                         buttonLabel,
                         buttonBorderRadius,
                         onFocus = null,
                         onBlur = null,
                         onCloseMobile= null,
                         isSmallDevice = false,
                     }) => {


    const getStyleOfIcon = () => {
        return {
            borderRadius: '50%',
            backgroundColor: `${submitBgColor}!important`,
            border: '1px solid',
            borderColor: `${submitBorderColor || '#FFF'} !important`,
            'svg': {
                height: (submitBgColor !== '' && submitBgColor.toLowerCase() !== '#fff' && submitBgColor.toLowerCase() !== '#ffffff') ? '20px' : '24px',
            },
            '&:hover, & > sgv:hover': {
                backgroundColor: `${submitBgHoverColor}!important`,
                borderColor: `${submitBorderHoverColor || '#FFF'} !important`,
            },

        };
    };

    const getStyleSearchField = () => {
        return {
            '& .ywcas-input-field-wrapper': {
                flex: 1,
                borderRadius: `${inputBorderRadius.topLeft} ${inputBorderRadius.topRight} ${inputBorderRadius.bottomRight} ${inputBorderRadius.bottomLeft}`,
                borderColor: `${inputBorderColor || '#7C7C7C'}!important`,
                borderWidth: `${inputBorderSize.topLeft} ${inputBorderSize.topRight}  ${inputBorderSize.bottomLeft} ${inputBorderSize.bottomRight}`,
                backgroundColor: `${inputBgColor || '#FFF'}!important`,
                borderStyle: 'solid',
                overflow: 'hidden',
                '&:focus-within': {
                    backgroundColor: `${inputBgFocusColor || '#FFF'}!important`,
                    borderColor: `${inputBorderFocusColor || '#5B5B5B'}!important`,
                },
                '& >div': {
                    width: '100%',
                    padding: 0,
                    input: {
                        flex: 1,
                    },
                    'div:last-child': {
                        display: 'none',
                    },
                },
            },
            '& .ywcas-input-field input': {
                color: `${inputTextColor || '#000'} !important`,
                fontSize: '1rem!important',
            },
            '& .ywcas-input-field input::placeholder': {
                color: `${placeholderTextColor || '#000'}`,
                opacity: 1, /* Firefox */
            },
            '& .ywcas-submit-button': {
                color: `${submitContentColor || '#fff'} !important`,
                backgroundColor: `${submitBgColor || '#a7ab06'} !important`,
                borderColor: `${submitBorderColor || '#FFF'} !important`,
                borderRadius: `${buttonBorderRadius.topLeft} ${buttonBorderRadius.topRight} ${buttonBorderRadius.bottomRight} ${buttonBorderRadius.bottomLeft}`,
            },
            '& .ywcas-submit-button:hover': {
                color: `${submitContentHoverColor || '#fff'} !important`,
                backgroundColor: `${submitBgHoverColor || '#a7ab06'} !important`,
                borderColor: `${submitBorderHoverColor || '#FFF'} !important`,
            },
            '& .ywcas-submit-icon': {
                color: `${submitContentColor || '#000'} !important`,
            },
            '&:hover .ywcas-submit-icon, & .ywcas-submit-icon:hover': {
                color: `${submitContentHoverColor || '#000'} !important`,
            },
        };
    };

    const handleSubmit = () => {
        if ('' !== queryString) {
            const path = YWCAS_SITE_URL + '?ywcas=1&post_type=product&lang=' + YWCAS_LANG + '&s=' + queryString;
            window.location.href = path;
        }
    };

    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSubmit();
        }
    };

    return (
        <>
            <Box className="ywcas-block-components-search-field" sx={getStyleSearchField()}>
                {isSmallDevice && <div className="mobile-search-close" onClick={onCloseMobile}><Icon
                    icon={CloseIcon()}/></div>}
                <Stack direction="row" spacing={0}>
                    <Stack className="ywcas-input-field-wrapper">
                        <Input
                            className="ywcas-input-field"
                            placeholder={placeholder}
                            autoComplete="off"
                            size={size}
                            value={queryString}
                            onChange={setSearchQuery}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            onKeyDown={onKeyDown}
                            startAdornment={(submitStyle === 'icon' && iconType === 'icon-left') ?
                                <Box className="ywcas-submit-wrapper" sx={getStyleOfIcon()}><Icon
                                    className="ywcas-submit-icon" icon={MagnifyingGlassIcon()}/></Box> : null}
                            endAdornment={<Submit submitStyle={submitStyle} buttonLabel={buttonLabel}
                                                  submitBgColor={submitBgColor}
                                                  iconType={iconType} onClick={handleSubmit}
                                                  wrapperStyle={getStyleOfIcon()}/>}
                        />
                    </Stack>

                </Stack>

            </Box>
        </>
    );
};

export default SearchField;